
import { Subscription } from "@/types/subscription";

export const getLocalSubscriptions = (): Subscription[] => {
  try {
    console.log("Getting subscriptions from localStorage");
    const data = localStorage.getItem("subscriptions");
    const subscriptions = data ? JSON.parse(data) : [];
    console.log("Retrieved subscriptions from localStorage:", subscriptions);
    return subscriptions;
  } catch (error) {
    console.error("Error getting subscriptions from localStorage:", error);
    return [];
  }
};

export const saveLocalSubscriptions = (subscriptions: Subscription[]) => {
  try {
    console.log("Saving subscriptions to localStorage:", subscriptions);
    localStorage.setItem("subscriptions", JSON.stringify(subscriptions));
  } catch (error) {
    console.error("Error saving subscriptions to localStorage:", error);
  }
};
